export default "__VITE_ASSET__BgkcOZxx__"